/**
 * WhatsApp prefill — keeps message in sync with the currently selected variant.
 * Listens for variant changes from product-form and rebuilds the wa.me URL.
 */
(function () {
  const wa = (window.theme && window.theme.whatsappNumber) || '';
  const number = wa.replace(/[^\d]/g, '');

  function buildMessage({ shopName, title, variantTitle, price, url, measurements }) {
    let msg = `Hi ${shopName}! 👋\n\nI'd like to order:\n*${title}*\nVariant: ${variantTitle}\nPrice: ${price}\n\nLink: ${url}`;
    if (measurements && Object.keys(measurements).length) {
      msg += '\n\nMy measurements:';
      for (const [k, v] of Object.entries(measurements)) {
        if (v) msg += `\n• ${k}: ${v}`;
      }
    }
    return msg;
  }

  function collectMeasurements(form) {
    if (!form) return {};
    const out = {};
    form.querySelectorAll('[data-measurements] input, [data-measurements] textarea').forEach((el) => {
      const match = el.name.match(/properties\[(.+?)\]/);
      if (match && el.value) out[match[1]] = el.value;
    });
    return out;
  }

  function refreshButton(btn) {
    const productTitle = btn.dataset.productTitle;
    const productUrl = btn.dataset.productUrl;
    if (!productTitle || !number) return;

    const form = btn.closest('section')?.querySelector('form[action*="/cart/add"]');
    const variantSelect = form?.querySelector('[name="id"]');
    const selectedOption = variantSelect?.options[variantSelect.selectedIndex];
    const variantTitle = selectedOption?.textContent.trim() || '';
    const price = btn.dataset.price || '';

    const measurements = collectMeasurements(form);

    const text = buildMessage({
      shopName: document.title.split('–').pop().trim() || 'there',
      title: productTitle,
      variantTitle,
      price,
      url: productUrl,
      measurements
    });

    btn.href = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
  }

  document.addEventListener('change', (e) => {
    if (e.target.closest('form[action*="/cart/add"]')) {
      document.querySelectorAll('[data-whatsapp-button]').forEach(refreshButton);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-whatsapp-button]').forEach(refreshButton);
  });
})();
